import { useMemo } from 'react';

import { useSessionData } from '@confluence/session-data';

import { getTableOptions } from '../utils/tableOptions';

export const useTableOptions = () => {
	const { featureFlags } = useSessionData();
	return useMemo(() => getTableOptions(featureFlags), [featureFlags]);
};
